import React from "react";

const WistiaIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_381)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.1128 6.26166C18.4702 4.11678 17.2592 3.52086 17.2592 3.52086C17.2592 3.52086 17.3189 5.26864 14.1024 5.64602C11.2432 5.98369 1.69324 5.72544 1.69324 5.72544L4.77067 9.26073C5.60459 10.214 6.0414 10.3332 6.97472 10.3926C7.90779 10.4523 9.97274 10.4326 11.3823 10.3332C12.911 10.214 15.0951 9.7175 16.5644 8.56563C17.2989 7.96974 17.954 7.15552 18.1128 6.26166Z",
  fill: "#54BBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0084 10.4723C17.9343 9.26073 18.3113 8.48625 18.3113 8.48625C18.3113 8.48625 19.0261 14.067 11.7 16.0927C9.45644 16.7084 4.37351 16.4104 3.55958 16.4104H1.67346L4.81032 12.9151C5.64425 11.9618 6.08106 11.763 7.01441 11.763C7.94743 11.763 10.1115 11.8624 11.3028 11.7433C13.4869 11.5447 15.1942 10.9885 16.0084 10.4723Z",
  fill: "#148EE1"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_381"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6667,
  height: 16.6667,
  fill: "white",
  transform: "translate(1.66663 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(WistiaIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;